import { Entity } from "@hds/entity-lib";

class ItemRawBiddingEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        rawEntries: []
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...ItemRawBiddingEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get eventDetailId() {
        return this._virtualDataModel.getProperty('eventDetailId');
    }
    set eventDetailId(newEventDetailId) {
        return this._virtualDataModel.setProperty('eventDetailId', newEventDetailId);
    }
    get rawEntries() {
        return this._virtualDataModel.getProperty('rawEntries');
    }
    appendRawEntry(newItemRawBiddingActivity) {
        if (!this._virtualDataModel.hasProperty('rawEntries')) {
            this._virtualDataModel.setProperty('rawEntries', []);
        }
        this.rawEntries.push(newItemRawBiddingActivity);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

//META PROPERTIES
Object.defineProperty(ItemRawBiddingEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'item-raw-bidding'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { ItemRawBiddingEntity };
export default ItemRawBiddingEntity;